module.exports = __webpack_public_path__ + "static/media/outdent.1912a931.svg";